import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { WebStorageService } from '../../../../services';

@Component({
  selector: 'app-lot-connection-mode',
  templateUrl: './lot-connection-mode.component.html',
  styleUrls: ['./lot-connection-mode.component.css'],
})
export class LotConnectionModeComponent implements OnInit {
  showConnectionNav: boolean;
  toggleSwitchOn: boolean;
  userLoggedIn: boolean = false;

  constructor(
    private storage: WebStorageService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.checkModeAvailability();
  }

  private checkModeAvailability() {
    this.route.data.subscribe((res: Data) => {
      this.showConnectionNav = res['lowConnectionNeeded'];
      if (this.showConnectionNav) this.initializeVariables();
    });
  }

  private initializeVariables() {
    this.userLoggedIn = this.storage.getBuyer()?.loggedIn;
    if (this.userLoggedIn) {
      this.toggleSwitchOn = !this.storage.getBuyer()?.lotLowConnectionMode;
    }
  }

  toggleChange(ev) {
    let btnPosition = !this.toggleSwitchOn;
    this.toggleSwitchOn = btnPosition;
    this.storage.setBuyer(null, null, !btnPosition);
    location.reload();
  }
}
